import http from "../../../core/utils/apis/api";

const getObjectivesAndUsers = async (trainingId) => {
  try {
    const response = await http({
      method: "GET",
      url: `/objectiveEvaluationScores/behavioral-objectives/${trainingId}`,
      params: {
        objectiveType: 'behavioral',
      },
    });
    return response;
  } catch (e) {
    throw e;
  }
};

const submitObjectivesEvaluationsScores = async (data) => {
  try {
    const response = await http({
      method: "POST",
      url: `/objectiveEvaluationScores/upsert`,
      data: data
    });
    return response;
  } catch (e) {
    throw e;
  }
};

const behavioralObjectivesService = {
    getObjectivesAndUsers,
    submitObjectivesEvaluationsScores,
};

export default behavioralObjectivesService;
